// 环境配置工具
// 统一管理环境变量和配置

export interface AppConfig {
  apiBaseUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
  environment: string;
}

/**
 * 获取API基础URL
 * 开发环境：使用代理路径
 * 生产环境：使用环境变量或默认域名
 */
const getApiBaseUrl = (): string => {
  // 开发环境使用代理
  if (import.meta.env.DEV) {
    return '/api';
  }
  
  // 生产环境使用环境变量或默认域名
  const envUrl = import.meta.env.VITE_API_BASE_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // 默认生产域名（需要替换为实际的Workers域名）
  return 'https://c.mindcraft.win/api';
};

/**
 * 获取应用配置
 */
export const getAppConfig = (): AppConfig => {
  return {
    apiBaseUrl: getApiBaseUrl(),
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    environment: import.meta.env.MODE,
  };
};

/**
 * 打印环境配置信息（仅开发环境）
 */
export const logEnvironmentInfo = (): void => {
  if (import.meta.env.DEV) {
    const config = getAppConfig();
    console.log('🔧 环境配置信息:', {
      environment: config.environment,
      apiBaseUrl: config.apiBaseUrl,
      isDevelopment: config.isDevelopment,
      isProduction: config.isProduction,
    });
  }
};

// 导出配置实例
export const appConfig = getAppConfig();
